export enum RecipeOriginType {
  ClientArea = 0,
  Sislog = 1,
  ShopifyAdmin = 2,
  ShopifyPOS = 3
}